import type { LscVodCandidate } from './types';

export const VOD_TRUTH_VERIFICATION_STATUS_REQUESTED = 'verification_requested';
export const VOD_TRUTH_VERIFICATION_STATUS_VIDEO_DOWNLOADING = 'video_downloading';
export const VOD_TRUTH_VERIFICATION_STATUS_RUNNING = 'verification_running';
export const VOD_TRUTH_VERIFICATION_STATUS_FAILED = 'verification_failed';

export const VOD_TRUTH_VERIFICATION_POLL_INTERVAL_MS = 3000;
export const VOD_TRUTH_VERIFICATION_MAX_POLL_ATTEMPTS = 45;

export type VodTruthVerificationStatus =
  | typeof VOD_TRUTH_VERIFICATION_STATUS_REQUESTED
  | typeof VOD_TRUTH_VERIFICATION_STATUS_VIDEO_DOWNLOADING
  | typeof VOD_TRUTH_VERIFICATION_STATUS_RUNNING
  | typeof VOD_TRUTH_VERIFICATION_STATUS_FAILED
  | null
  | undefined;

export function truthVerificationStatusFromCandidate(
  candidate: Pick<LscVodCandidate, 'truth_verification_status'>
): string | null {
  const status = String(candidate.truth_verification_status ?? '').trim();
  return status || null;
}

export function truthVerificationInProgress(
  candidate: Pick<
    LscVodCandidate,
    'truth_verification_status' | 'truth_checked_at' | 'truth_verification_progress_label'
  >
): boolean {
  if (candidate.truth_checked_at) {
    return false;
  }
  const status = truthVerificationStatusFromCandidate(candidate);
  return (
    status === VOD_TRUTH_VERIFICATION_STATUS_REQUESTED ||
    status === VOD_TRUTH_VERIFICATION_STATUS_VIDEO_DOWNLOADING ||
    status === VOD_TRUTH_VERIFICATION_STATUS_RUNNING
  );
}

export function truthVerificationFailed(
  candidate: Pick<LscVodCandidate, 'truth_verification_status' | 'truth_checked_at'>
): boolean {
  if (candidate.truth_checked_at) {
    return false;
  }
  return (
    truthVerificationStatusFromCandidate(candidate) ===
    VOD_TRUTH_VERIFICATION_STATUS_FAILED
  );
}

export function truthVerificationPollComplete(
  candidate: Pick<LscVodCandidate, 'truth_verification_status' | 'truth_checked_at'>
): boolean {
  if (candidate.truth_checked_at) {
    return true;
  }
  return truthVerificationFailed(candidate);
}

export function truthVerificationProgressLabel(
  candidate: Pick<LscVodCandidate, 'truth_verification_status' | 'truth_verification_progress_label'>
): string {
  const apiLabel = String(candidate.truth_verification_progress_label ?? '').trim();
  if (apiLabel) {
    return apiLabel;
  }
  const status = truthVerificationStatusFromCandidate(candidate);
  if (status === VOD_TRUTH_VERIFICATION_STATUS_VIDEO_DOWNLOADING) {
    return 'Downloading VOD from Twitch...';
  }
  if (status === VOD_TRUTH_VERIFICATION_STATUS_RUNNING) {
    return 'Analyzing video windows...';
  }
  if (status === VOD_TRUTH_VERIFICATION_STATUS_REQUESTED) {
    return 'Verification queued...';
  }
  return 'Checking scoreboard and gamertags...';
}
